module.exports = __webpack_public_path__ + "images/1-h21c4b1831e6255dca62ece1965eddaf0.svg";